import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import {  isAllTokenInvalid } from '../../core/utility';


const RenderResult = ({ component: Component, ...rest }: any): JSX.Element => {

    return (
        <Route
            {...rest}
            render={props => {
                if (!isAllTokenInvalid()) {
                    return Component ? ( //login ise
                        <Component {...props} />
                    ) : (
                        rest.render(props)
                    );
                }
                return (
                    <Redirect
                        to={{
                            //login değil ise
                            pathname: '/accounts/login',
                            state: {
                                from: rest.location.pathname + rest.location.search,
                            },
                        }}
                    />
                );
            }}
        />
    );
};
RenderResult.displayName = 'privateRoute';
export default RenderResult;
